import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import moment from 'moment'

import { FORMAT_DATE_TRUNC } from 'constants/config'
import columns from 'component/report/stockAdjustment/adjustmentDone/columns'
import CommonReport from 'component/commonReport/CommonReport'

import applyMask from 'component/report/utils/Formatter'
import { formatDecimalDynamic } from 'utils/masks'

import * as adjustmentDoneActions from 'action/adjustmentDone'
import * as reportActions from 'action/report'
import Checkbox from 'component/Checkbox/newCheckbox'

const DEFAULT_LIMIT = 50

const DONE_ADJUSTMENTS_REPORT = 17

class StockAdjustmentDone extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    records: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    count: PropTypes.number,
    isFetching: PropTypes.bool,
  }

  constructor() {
    super()

    this.state = {
      filters: {},
      initialValues: {
        cdLm: '',
        cdSection: [],
        dtEnd: null,
        dtStart: null,
        period: [null, null],
        listRegionsAndBranchs: [],
      },
      sideFilterWidth: 0,
      topMargin: 0,
      includeLot: 0,
      update: false,
      callback: () => {},
    }
  }

  handleFetchAdjustmentDone = (filters, callback) => {
    const initialValues = this.getInitialValues(filters)

    const setStateCallback = async () => {
      const {
        auth: {
          user: { dsToken },
        },
        fetch,
      } = this.props

      const params = this.getParams(filters)
      delete params.period
      delete params.listRegionsAndBranchs

      this.setState({ update: false })

      await fetch(dsToken, params)

      callback(this.buildRows())
    }

    this.setState({ filters, initialValues, callback }, setStateCallback)
  }

  buildRows() {
    const { records, count, translate } = this.props
    const response = { total: count, data: [] }

    for (const row of records) {
      for (const col in columns) {
        const column = columns[col]
        if (column.render) {
          if (
            column.field === 'dsStatus' &&
            (row[column.field] === undefined || row[column.field] === null || row[column.field] === '') &&
            row.tpStatus !== undefined &&
            row.tpStatus !== null
          ) {
            row[column.field] = this.renderFieldValue(
              'tpStatus',
              row.tpStatus,
              translate,
              column.t,
              row.numHouses
            )
          } else if (row[column.field] !== undefined) {
            row[column.field] = this.renderFieldValue(
              column.type,
              row[column.field],
              translate,
              column.t,
              row.numHouses
            )
          } else row[column.field] = '-'
        }
      }
    }

    response.data = records

    return response
  }

  renderFieldValue = (type, field, translate, headerLabel, numHouses) => {
    if (type === 'decimal') {
      if (field) {
        return formatDecimalDynamic(field, numHouses, translate)
      }
      return ''
    }
    return applyMask(type, field, translate, headerLabel)
  }

  getParams = (filters) => ({
    ...filters,
    cdSection: null,
    countIrc: true,
    dtEnd: moment(filters.period[1]).format(FORMAT_DATE_TRUNC),
    dtStart: moment(filters.period[0]).format(FORMAT_DATE_TRUNC),
    idBranches: filters.listRegionsAndBranchs,
    lsSections: filters.cdSection || [],
    includeLot: this.state.includeLot,
  })

  getInitialValues = (filters) => {
    const initialValues = { ...filters }

    initialValues.cdSection = initialValues.cdSectionForInitialValues
    initialValues.dtStart = initialValues.dtStart
      ? moment(initialValues.period[0], FORMAT_DATE_TRUNC)
      : null
    initialValues.dtEnd = initialValues.dtEnd
      ? moment(initialValues.period[1], FORMAT_DATE_TRUNC)
      : null

    return initialValues
  }

  getCsv = async (callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchReports,
    } = this.props

    const { filters } = this.state

    const values = { tpReport: DONE_ADJUSTMENTS_REPORT }

    const params = this.getParams(filters)
    delete params.period
    delete params.listRegionsAndBranchs

    await fetchReports(dsToken, values, params)

    callback()
  }

  get columnsWithoutLot() {
    const copy = { ...columns }
    delete copy.dsLot
    return copy
  }

  get fields() {
    const {
      auth: { user }
    } = this.props

    return [
      {
        help_text: 'feature-check.store',
        label: 'field.store',
        name: 'listRegionsAndBranchs',
        required: !user.isLdapInManager,
        type: 'branchs',
      },
      {
        help_text: 'select.section',
        label: 'section',
        name: 'cdSection',
        type: 'sections',
      },

      {
        help_text: 'mobile.hint.lm',
        label: 'field.lm.hint',
        name: 'cdLm',
        type: 'cd_lm',
        maxLength: 8
      },
      {
        type: 'date_range',
        name: 'period',
        label: 'adjustmentValues.date.period',
        error_text: 'adjustmentValues.date.select',
        required: true,
      },

      {
      type: 'radio_group',
      name: 'integratedStatus',
      label: '',
      translate: true,
      title: "",
     
      required: false,
      initial: 2,
      options: [
        { value: 1, label: 'stock.adjustment.done.integrated' },
        { value: 3, label: 'stock.adjustment.done.notIntegrated' },
        { value: 2, label: 'stock.adjustment.done.all' },
      ],
    },
    ]
  }

  render() {
    const {
      auth: { user },
      translate,
      isFetching,
    } = this.props
    const { filters, callback, includeLot, update } = this.state

    const translateFieldsLabels = (field) => ({
      ...field,
      error_text: translate(field.error_text),
      help_text: translate(field.help_text),
      label: translate(field.label),
    })

    // Create a deep copy of columns to avoid modifying the imported object
    const modifiedColumns = JSON.parse(JSON.stringify(columns))
    const modifiedColumnsWithoutLot = JSON.parse(JSON.stringify(this.columnsWithoutLot))

    // Set fixed columns for horizontal scrolling
    modifiedColumns.dtInventory.fixed = true
    modifiedColumns.ldap.fixed = true
    modifiedColumns.dsBranch.fixed = true
    modifiedColumns.cdLm.fixed = true

    modifiedColumnsWithoutLot.dtInventory.fixed = true
    modifiedColumnsWithoutLot.ldap.fixed = true
    modifiedColumnsWithoutLot.dsBranch.fixed = true
    modifiedColumnsWithoutLot.cdLm.fixed = true

    // Apply translations and ordering settings
    const applySettings = (cols) => {
      for (const col in cols) {
        cols[col].label = translate(cols[col].t)
        if (col !== 'dtInventory') {
          cols[col].disableOrder = true
        }
      }
      return cols
    }

    const finalColumns = !includeLot || update || isFetching ? applySettings(modifiedColumnsWithoutLot) : applySettings(modifiedColumns)

    return (
      <CommonReport
        columns={finalColumns}
        fields={this.fields.map(translateFieldsLabels)}
        limit={DEFAULT_LIMIT}
        onExport={this.getCsv}
        onSubmit={this.handleFetchAdjustmentDone}
        title={translate('stockAdjustment.report.doneAdjustments.title')}
        user={user}
        order
        defaultOrder={'dtInventory'}
        translate={translate}
        topLeftPart={() => (
          <Checkbox
            label={translate('rotativeInventory.showBatch')}
            onChange={(e) => {
              this.setState(
                {
                  includeLot: e ? 1 : 0,
                  update: true,
                },
                () => this.handleFetchAdjustmentDone({...filters, page: 1}, callback)
              )
            }}
          />
        )}
        update={update}
      />
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ adjustmentDoneReducer, paginateReducer }) => ({
  records: adjustmentDoneReducer.records,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...adjustmentDoneActions, ...reportActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    StockAdjustmentDone
  )
)

export { StockAdjustmentDone }
